import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import emptyBoxAnimation from '../assets/animations/empty_box.json';

/**
 * EmptyState Component - Shows animated empty box when no data available
 * @param {string} title - Main message to display
 * @param {string} subtitle - Secondary message (optional)
 * @param {number} size - Animation size in pixels (default: 150)
 */
export const EmptyState = ({ title, subtitle, size = 150 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center py-8"
      data-testid="empty-state"
    >
      <div style={{ width: size, height: size }}>
        <Lottie
          animationData={emptyBoxAnimation}
          loop={true}
          autoplay={true}
        />
      </div>
      <p className="text-zinc-400 font-medium mt-2 text-center">{title}</p>
      {subtitle && (
        <p className="text-zinc-600 text-sm mt-1 text-center">{subtitle}</p>
      )}
    </motion.div>
  );
};

export default EmptyState;
